import { ReactNode } from "react";
import { useNavigate } from "react-router";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import Box from "ds/components/Box";
import useTitle from "hooks/useTitle";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Tab from "ds/components/Tab";

import { FILTERS_ORDER_SETTINGS_KEY as ROLES_FILTERS_ORDER_SETTINGS_KEY } from "../Roles/constants";
import RoleActions from "./RoleActions";
import { RoleView } from "./types";

type RolePageLayoutProps = {
  children: ReactNode;
  role: RoleView;
  readOnly?: boolean;
};

const RolePageLayout = ({ children, role, readOnly }: RolePageLayoutProps) => {
  const navigate = useNavigate();

  useTitle(`Role · ${role.name}`);

  useBreadcrumbs(
    [
      {
        title: "Organization Settings",
      },
      {
        title: "Roles",
        link: getBreadcrumbsBackUrl("/settings/roles", ROLES_FILTERS_ORDER_SETTINGS_KEY),
      },
      {
        title: role.name,
      },
    ],
    []
  );

  return (
    <>
      <ViewHeader firstLevel>
        <Box fullWidth justify="between" align="center">
          <ViewHeaderTitle tag="h2">{role.name}</ViewHeaderTitle>

          <RoleActions
            role={role}
            analyticsPage={AnalyticsPageOrganization.OrganizationRole}
            onDeleteSuccess={() => navigate("/settings/roles", { replace: true })}
            size="medium"
            refetchQueries={["GetRole"]}
            readOnly={readOnly}
          />
        </Box>
        <ViewHeaderNavigation role="tablist">
          <Tab end to={`/settings/role/${role.id}`} label="Permissions" />
          <Tab to={`/settings/role/${role.id}/used-by`} label="Used by" />
        </ViewHeaderNavigation>
      </ViewHeader>

      {children}
    </>
  );
};

export default RolePageLayout;
